import { createFileRoute } from '@tanstack/react-router';
import { ProposePage } from '@/features/metric-hub/propose/ProposePage';

/**
 * Edit-existing-draft route.
 *
 * Renders `<ProposePage>` in edit mode (`editingDraftId` set) so the
 * author can mutate the in-flight draft via PATCH — definition body,
 * dimensions, filters, notes AND implementations. The author lands here
 * after a reviewer says "request changes": the AuthorActions card on
 * the draft page links straight in.
 *
 * URL: `/metric-hub/drafts/<slug>/<draftId>/edit`. Sibling of the read
 * route at `/metric-hub/drafts/<slug>/<draftId>`. The API still PATCHes
 * `/metric-hub/metrics/:slug/drafts/:draftId` — the route is purely
 * frontend.
 */
export const Route = createFileRoute('/_authed/metric-hub/drafts/$slug/$draftId/edit')({
  component: EditDraftRoute,
});

function EditDraftRoute() {
  const { slug, draftId } = Route.useParams();
  return <ProposePage fromSlug={slug} editingDraftId={draftId} />;
}
